/**
 * Admin pricing API. Read-only browse of the per-country market_pricing
 * table. Mutations deferred (see services/admin-api/src/routes/pricing.ts
 * docstring for the rationale).
 */

import { useQuery } from '@tanstack/react-query';
import { ADMIN_API_BASE, apiFetch } from './client.js';

export interface PricingRow {
  countryCode: string;
  currency: string;
  pack1PriceMinor: number;
  pack10PriceMinor: number;
  pack25PriceMinor: number;
  stripePriceId1: string | null;
  stripePriceId10: string | null;
  stripePriceId25: string | null;
  updatedAt: string;
}

export const pricingKeys = {
  all: ['admin-pricing'] as const,
  list: () => [...pricingKeys.all, 'list'] as const,
} as const;

export function usePricingQuery() {
  return useQuery({
    queryKey: pricingKeys.list(),
    queryFn: () =>
      apiFetch<{ rows: PricingRow[] }>({
        method: 'GET',
        url: '/admin/pricing',
        baseUrl: ADMIN_API_BASE,
      }),
  });
}
